import React from "react";
import bg_video from "./star2.mp4";
import bg_photo from "./vue.png";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "./Particle";
import Home2 from "./Home2";
import Type from "./Type";
import "./style.css";

function Home() {
  return (  
    <>
    <section className="col-12 col-sm-12 home-bg" style={{height:'100vh'}} >
      <Container fluid className="home-section border-2 border-bg-zinc-50"  id="home">
      
        <Particle />
        
        <Container className="home-content " >
          
          <Row className="">
            <Col  className="home-header float-center">
            <video className="mobile-video" src={bg_video} autoPlay muted loop id="myVideo1"></video>
              <h1 style={{ paddingBottom: 15 }} className="heading tiltneon">
                Hello
                <span className="wave" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading">
                <strong className=" tiltneon " style={{fontSize:'4vh'}}>
                  {" "}
                  I am <Type />
                </strong>
              </h1>
            </Col>
          </Row>
          
        </Container>
        
      </Container>
      
    </section>
    <Home2 />
    </>
  );
}

export default Home;
